import React from 'react'

const RedBackground = ({children}) => {
    return (
        <div className="front-red-bg">{children}</div>
    )
}

export default RedBackground